/**
 * Inline color style for a "chip" (tag/category pill). Inline on purpose: it must
 * beat the admin theme's button styling (`.btn--default--solid`), which a class-based
 * rule loses to on specificity.
 *
 * Colors come from data: an explicit trio (categories) or a single `color` (tags,
 * derived to a pastel). In dark mode foreground/background are swapped.
 *
 * @param option Object with `color_background/color_text/color_border` or `color`.
 * @param isDark Whether dark mode is active.
 * @returns Inline style object with backgroundColor/color/borderColor.
 */
export function chipStyle(
    option: any,
    isDark: boolean,
): { backgroundColor: string; color: string; borderColor: string } {
    const swap = (bg: string, fg: string, bd: string) =>
        isDark ? { backgroundColor: fg, color: bg, borderColor: bd } : { backgroundColor: bg, color: fg, borderColor: bd };

    if (option && typeof option === 'object') {
        if (option.color_background || option.color_text || option.color_border) {
            return swap(option.color_background, option.color_text, option.color_border);
        }

        if (option.color) {
            return swap(
                `color-mix(in srgb, ${option.color} 15%, white)`,
                `color-mix(in srgb, ${option.color} 65%, black)`,
                option.color,
            );
        }
    }

    // Neutral chip (no color) — theme-aware grays via CSS variables.
    return isDark
        ? { backgroundColor: 'var(--color-gray-800)', color: 'var(--color-gray-200)', borderColor: 'var(--color-gray-600)' }
        : { backgroundColor: 'var(--color-gray-100)', color: 'var(--color-gray-700)', borderColor: 'var(--color-gray-300)' };
}
